const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAilogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 10.1875 18.277344 C 9.875 18.59375 6.953125 19.539062 6.890625 19.578125 L 8.382812 19.769531 L 10.1875 19.433594 Z M 10.1875 18.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.890625 17.121094 C 6.953125 17.058594 7.773438 16.261719 7.773438 16.261719 C 7.738281 17.300781 7.5625 18.390625 7.480469 18.800781 L 7.101562 19.074219 C 7.101562 19.074219 6.890625 17.246094 6.890625 17.121094 Z M 6.890625 17.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.578125 19.496094 L 5.757812 18.765625 C 5.84375 18.691406 6.714844 18.792969 7.144531 18.851562 L 7.144531 19.050781 Z M 6.578125 19.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 5.734375 18.761719 C 5.601562 18.339844 5.863281 18.128906 6.03125 17.351562 C 6.28125 17.480469 6.617188 17.226562 6.910156 17.101562 C 6.847656 17.3125 7.101562 18.296875 7.144531 18.886719 C 6.605469 18.820312 5.980469 18.773438 5.734375 18.761719 Z M 5.734375 18.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.03125 17.375 C 6.011719 17.054688 5.617188 16.722656 5.421875 16.597656 C 5.460938 16.582031 5.664062 16.554688 6.050781 16.640625 C 6.101562 16.539062 6.890625 16.167969 7.289062 15.988281 L 7.773438 16.007812 C 7.792969 16.023438 7.820312 16.105469 7.753906 16.324219 C 7.480469 16.574219 6.996094 17.164062 6.46875 17.332031 C 6.425781 17.347656 6.261719 17.4375 6.03125 17.375 Z M 6.03125 17.375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 7.480469 15.609375 L 5.652344 15.566406 C 5.652344 15.535156 5.734375 15.105469 5.777344 14.894531 Z M 7.480469 15.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 5.628906 15.566406 C 5.34375 15.464844 5.148438 15.078125 5.085938 14.894531 C 5.070312 14.851562 5.460938 14.746094 5.566406 14.769531 C 5.652344 14.8125 5.761719 14.847656 5.796875 14.875 C 5.792969 14.980469 5.730469 15.28125 5.628906 15.566406 Z M 5.628906 15.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 9.578125 14.894531 L 9.578125 11.878906 C 9.746094 11.765625 10.035156 11.519531 10.167969 11.40625 C 10.195312 12.351562 10.257812 14.28125 10.273438 14.433594 C 10.289062 14.582031 9.816406 14.804688 9.578125 14.894531 Z M 9.578125 14.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.46875 13.867188 L 7.753906 15.546875 L 8.738281 15.230469 L 8.359375 14.117188 L 6.742188 13.488281 Z M 6.46875 13.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 5.460938 13.929688 C 5.480469 13.996094 5.230469 14.601562 5.105469 14.894531 C 5.175781 14.859375 5.460938 14.789062 5.566406 14.789062 C 5.671875 14.8125 6.785156 15.441406 7.457031 15.609375 L 7.773438 15.566406 L 6.46875 13.867188 L 6.742188 13.488281 C 6.722656 13.425781 6.742188 13.402344 6.703125 13.296875 C 6.03125 14.097656 5.777344 13.96875 5.460938 13.929688 Z M 5.460938 13.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 7.519531 13.800781 L 8.363281 14.117188 C 8.394531 13.511719 8.765625 12.5625 8.949219 12.164062 L 8.90625 11.722656 C 8.835938 11.636719 8.632812 11.457031 8.296875 11.574219 C 7.960938 11.761719 7.324219 11.625 7.058594 11.511719 Z M 7.519531 13.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 8.886719 11.703125 L 8.929688 12.144531 C 9.585938 12.261719 11.34375 10.300781 12.144531 9.308594 C 11.933594 9.347656 11.414062 9.429688 11.03125 9.410156 C 10.644531 9.394531 9.136719 11.21875 8.886719 11.703125 Z M 8.886719 11.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 8.277344 11.617188 C 8.578125 11.535156 8.808594 11.652344 8.886719 11.722656 C 8.886719 11.570312 10.050781 10.316406 10.628906 9.707031 C 10.558594 9.613281 10.296875 9.464844 9.8125 9.601562 C 8.992188 9.894531 8.425781 11.132812 8.277344 11.617188 Z M 8.277344 11.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 8.886719 10.398438 L 7.585938 10.398438 L 7.058594 11.554688 C 7.414062 11.660156 7.855469 11.742188 8.296875 11.617188 C 8.296875 11.46875 8.664062 10.757812 8.886719 10.398438 Z M 8.886719 10.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.449219 11.40625 L 7.164062 10.378906 L 7.605469 10.398438 L 7.058594 11.574219 Z M 6.449219 11.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 7.078125 11.554688 L 7.542969 13.800781 L 6.722656 13.488281 L 6.449219 11.40625 Z M 7.078125 11.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 7.207031 10.167969 L 7.816406 10 L 6.996094 9.433594 Z M 7.207031 10.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 8.089844 3.65625 L 7.648438 3.191406 L 5.460938 5.230469 L 5.335938 7.855469 L 6.070312 8.046875 L 6.429688 5.566406 Z M 8.089844 3.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 12.5 0 C 19.402344 0 25 5.597656 25 12.5 C 25 19.402344 19.402344 25 12.5 25 C 5.597656 25 0 19.402344 0 12.5 C 0 5.597656 5.597656 0 12.5 0 Z M 12.5 0.882812 C 6.089844 0.882812 0.886719 6.078125 0.886719 12.5 C 0.886719 18.378906 5.25 23.230469 10.902344 24.007812 L 10.902344 17.332031 L 11.660156 17.332031 L 11.660156 24.085938 C 11.9375 24.109375 12.21875 24.117188 12.5 24.117188 C 12.65625 24.117188 12.808594 24.113281 12.960938 24.109375 L 12.960938 13.777344 L 13.972656 12.722656 C 13.957031 12.65625 13.949219 12.589844 13.949219 12.519531 C 13.949219 12.035156 14.34375 11.640625 14.832031 11.640625 C 15.175781 11.640625 15.472656 11.835938 15.617188 12.121094 L 19.757812 12.121094 C 19.90625 11.835938 20.203125 11.640625 20.546875 11.640625 C 21.035156 11.640625 21.429688 12.035156 21.429688 12.519531 C 21.429688 13.007812 21.035156 13.402344 20.546875 13.402344 C 20.1875 13.402344 19.875 13.1875 19.738281 12.878906 L 15.640625 12.878906 C 15.5 13.1875 15.191406 13.402344 14.832031 13.402344 C 14.695312 13.402344 14.5625 13.371094 14.449219 13.316406 L 13.71875 14.078125 L 13.71875 24.054688 C 13.945312 24.03125 14.167969 24 14.390625 23.964844 L 14.390625 15.832031 L 15.621094 14.601562 L 23.90625 14.601562 L 23.90625 14.6875 C 24.019531 14.097656 24.085938 13.496094 24.105469 12.878906 L 22.164062 12.878906 L 22.164062 12.121094 L 24.105469 12.121094 C 24.089844 11.570312 24.035156 11.03125 23.941406 10.503906 L 13.265625 10.503906 L 11.890625 11.878906 L 11.890625 14.371094 L 11.132812 14.371094 L 11.132812 11.566406 L 12.953125 9.746094 L 23.785156 9.746094 C 23.511719 8.625 23.078125 7.566406 22.503906 6.597656 L 14.160156 6.597656 L 14.160156 2.6875 L 10.0625 2.6875 L 10.0625 1.933594 L 14.914062 1.933594 L 14.914062 5.839844 L 22.015625 5.839844 C 21.65625 5.324219 21.253906 4.839844 20.816406 4.390625 L 17.949219 4.390625 C 17.796875 4.65625 17.511719 4.832031 17.183594 4.832031 C 16.699219 4.832031 16.300781 4.4375 16.300781 3.949219 C 16.300781 3.460938 16.699219 3.066406 17.183594 3.066406 C 17.5625 3.066406 17.882812 3.304688 18.007812 3.632812 L 20.003906 3.632812 C 17.980469 1.917969 15.359375 0.882812 12.5 0.882812 Z M 15.933594 15.355469 L 15.148438 16.144531 L 15.148438 23.8125 C 15.421875 23.75 15.695312 23.675781 15.960938 23.59375 L 15.820312 23.59375 L 15.820312 17.171875 L 16.632812 16.386719 L 23.449219 16.386719 L 23.320312 16.730469 C 23.492188 16.285156 23.640625 15.828125 23.757812 15.355469 Z M 16.9375 17.144531 L 16.574219 17.492188 L 16.574219 23.382812 C 17.097656 23.1875 17.601562 22.953125 18.082031 22.6875 L 17.898438 22.984375 L 17.898438 20.019531 C 17.625 19.871094 17.4375 19.578125 17.4375 19.242188 C 17.4375 18.757812 17.832031 18.363281 18.320312 18.363281 C 18.628906 18.363281 18.898438 18.519531 19.058594 18.761719 L 22.378906 18.761719 L 22.164062 18.945312 C 22.542969 18.378906 22.871094 17.773438 23.148438 17.144531 Z M 19.160156 19.515625 C 19.078125 19.761719 18.894531 19.960938 18.65625 20.058594 L 18.65625 22.351562 C 19.851562 21.601562 20.90625 20.640625 21.757812 19.515625 Z M 18.320312 18.867188 C 18.109375 18.867188 17.941406 19.035156 17.941406 19.242188 C 17.941406 19.453125 18.109375 19.621094 18.320312 19.621094 C 18.527344 19.621094 18.699219 19.453125 18.699219 19.242188 C 18.699219 19.035156 18.527344 18.867188 18.320312 18.867188 Z M 11.34375 14.957031 C 11.832031 14.957031 12.226562 15.351562 12.226562 15.839844 C 12.226562 16.328125 11.832031 16.722656 11.34375 16.722656 C 10.855469 16.722656 10.460938 16.328125 10.460938 15.839844 C 10.460938 15.351562 10.855469 14.957031 11.34375 14.957031 Z M 11.34375 15.460938 C 11.136719 15.460938 10.964844 15.632812 10.964844 15.839844 C 10.964844 16.050781 11.136719 16.21875 11.34375 16.21875 C 11.554688 16.21875 11.722656 16.050781 11.722656 15.839844 C 11.722656 15.632812 11.554688 15.460938 11.34375 15.460938 Z M 14.832031 12.144531 C 14.625 12.144531 14.453125 12.3125 14.453125 12.519531 C 14.453125 12.730469 14.625 12.898438 14.832031 12.898438 C 15.039062 12.898438 15.210938 12.730469 15.210938 12.519531 C 15.210938 12.3125 15.039062 12.144531 14.832031 12.144531 Z M 13.425781 4.097656 L 12.425781 4.097656 L 10.652344 5.871094 L 10.652344 7.175781 L 11.355469 7.898438 L 21.367188 7.898438 L 21.367188 7.902344 C 21.515625 7.625 21.808594 7.4375 22.144531 7.4375 C 22.628906 7.4375 23.023438 7.832031 23.023438 8.320312 C 23.023438 8.804688 22.628906 9.203125 22.144531 9.203125 C 21.773438 9.203125 21.460938 8.976562 21.328125 8.65625 L 11.039062 8.65625 L 9.894531 7.484375 L 9.894531 5.558594 L 12.113281 3.339844 L 13.425781 3.339844 Z M 12.183594 5.546875 C 12.671875 5.546875 13.066406 5.941406 13.066406 6.429688 C 13.066406 6.914062 12.671875 7.3125 12.183594 7.3125 C 11.699219 7.3125 11.300781 6.914062 11.300781 6.429688 C 11.300781 5.941406 11.699219 5.546875 12.183594 5.546875 Z M 17.183594 3.570312 C 16.976562 3.570312 16.808594 3.742188 16.808594 3.949219 C 16.808594 4.160156 16.976562 4.328125 17.183594 4.328125 C 17.394531 4.328125 17.5625 4.160156 17.5625 3.949219 C 17.5625 3.742188 17.394531 3.570312 17.183594 3.570312 Z M 8.824219 2.226562 C 9.054688 2.226562 9.242188 2.414062 9.242188 2.648438 C 9.242188 2.878906 9.054688 3.066406 8.824219 3.066406 C 8.589844 3.066406 8.402344 2.878906 8.402344 2.648438 C 8.402344 2.414062 8.589844 2.226562 8.824219 2.226562 Z M 8.824219 2.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 9.789062 3.277344 L 10.882812 3.382812 L 9.035156 5.316406 L 9.035156 7.605469 L 10.292969 8.949219 L 9.371094 8.949219 L 7.5625 7.269531 L 7.792969 5.1875 Z M 9.789062 3.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 7.015625 7.753906 L 6.933594 4.980469 L 6.429688 5.546875 L 6.070312 8.023438 Z M 7.015625 7.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.070312 8.046875 L 5.335938 7.855469 L 5.757812 9.539062 L 6.34375 9.875 Z M 6.070312 8.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 7.015625 7.753906 L 6.070312 8.023438 L 6.113281 8.359375 L 6.617188 8.800781 L 8.929688 9.578125 Z M 7.015625 7.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 7.816406 10 L 6.996094 9.433594 L 8.632812 9.832031 Z M 7.816406 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.34375 9.875 L 4.664062 12.164062 C 4.246094 12.105469 4 12.289062 3.898438 12.429688 L 3.867188 12.480469 C 3.875 12.464844 3.882812 12.445312 3.898438 12.429688 L 5.757812 9.539062 Z M 6.34375 9.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 4.726562 12.105469 C 4.214844 11.984375 3.925781 12.335938 3.84375 12.527344 C 4.40625 12.503906 4.324219 12.550781 4.671875 12.753906 C 4.351562 12.476562 4.621094 12.304688 4.726562 12.105469 Z M 4.726562 12.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 4.726562 12.714844 L 4.679688 12.816406 L 3.890625 12.855469 C 3.882812 12.816406 3.863281 12.703125 3.84375 12.519531 C 4.242188 12.4375 4.578125 12.617188 4.726562 12.714844 Z M 4.726562 12.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 3.90625 12.898438 L 3.886719 12.855469 L 4.601562 12.816406 C 4.609375 12.808594 4.621094 12.777344 4.621094 12.710938 C 4.351562 12.558594 4.511719 12.296875 4.621094 12.183594 C 4.882812 12.339844 5.449219 12.644531 5.566406 12.710938 C 5.714844 12.792969 5.839844 12.941406 5.796875 13.195312 C 5.460938 12.855469 4.390625 12.855469 3.90625 12.898438 Z M 3.90625 12.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 4.011719 13.109375 L 3.90625 12.898438 L 4.285156 12.878906 L 4.683594 12.878906 L 5.148438 13.78125 Z M 4.011719 13.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 5.148438 13.78125 L 6.113281 13.402344 C 5.558594 12.914062 4.929688 12.863281 4.683594 12.898438 Z M 5.148438 13.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 5.484375 13.949219 L 5.125 14.875 C 5.429688 14.773438 5.558594 14.777344 5.589844 14.789062 C 5.671875 14.578125 5.847656 14.125 5.882812 13.992188 C 5.796875 14.023438 5.582031 13.976562 5.484375 13.949219 Z M 5.484375 13.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 5.335938 16.46875 C 5.335938 16.335938 5.546875 16.050781 5.652344 15.925781 C 5.71875 15.976562 6.757812 16 7.269531 16.007812 C 6.847656 16.132812 6.15625 16.640625 6.007812 16.640625 C 5.925781 16.640625 5.628906 16.589844 5.484375 16.597656 C 5.472656 16.601562 5.457031 16.601562 5.441406 16.601562 C 5.390625 16.601562 5.335938 16.574219 5.335938 16.46875 Z M 5.335938 16.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgba(0, 0, 0, 0.85)",
      fillOpacity: 1
    },
    d: "M 6.113281 10.210938 L 4.621094 12.183594 C 4.902344 12.347656 5.539062 12.691406 5.671875 12.792969 C 5.808594 12.894531 5.8125 13.117188 5.796875 13.214844 L 6.113281 13.402344 Z M 6.113281 10.210938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAilogoWhite);
export default __webpack_public_path__ + "static/media/ailogo-white.c900f8e24ae4f63e844eb8eceb29bad8.svg";
export { ForwardRef as ReactComponent };